<template>
    <div class="course-container">
        <headerPage />

        <div class="main-content">
            <!-- 左侧视频播放区域 -->
            <div class="video-section" ref="videoContainer">
                <div class="title-wrapper">
                    <el-button @click="goBack()" type="text" icon="el-icon-arrow-left"
                        class="return-button">返回</el-button>
                    <span class="divider">|</span>
                    <!-- 章节标题移到这里 -->
                    <div class="chapter-title">{{ currentChapter.title }}</div>
                </div>

                <div class="video-wrapper">
                    <!-- <iframe class="video-player" src="https://www.youtube.com/embed/dQw4w9WgXcQ" frameborder="0"
                        allowfullscreen></iframe> -->
                    <div id="J_prismPlayer" class="video-player"></div>
                </div>
            </div>

            <!-- 右侧章节列表 -->
            <div class="chapter-list" :style="{ height: videoHeight + 'px' }">
                <el-scrollbar class="scrollbar">
                    <el-menu :default-active="currentChapter.id" class="chapter-menu" @select="handleSelect">
                        <el-menu-item v-for="chapter in chapters" :key="chapter.id" :index="chapter.id">
                            {{ chapter.title }}
                        </el-menu-item>
                    </el-menu>
                </el-scrollbar>
            </div>
        </div>

        <bottomPage />
    </div>
</template>

<script>
import headerPage from "@/components/header/header";
import bottomPage from "@/components/bottom/bottom";

import Aliplayer from 'aliyun-aliplayer';
import 'aliyun-aliplayer/build/skins/default/aliplayer-min.css';

import * as VodApi from "@/api/vod";
import * as CourseApi from "@/api/course";

export default {
    components: {
        headerPage,
        bottomPage,
    },
    data() {
        return {
            classId: 0,
            courseId: 0,
            chapters: [],
            currentChapter: {
                id: '',
                chapterTitle: '',
            },
            videoHeight: 0,
            playerInstance: null, // 播放器实例
        };
    },
    created() {
        this.classId = this.$route.params.classId;
        this.courseId = this.$route.params.courseId;
        this.loadCourse();
    },
    mounted() {
        this.updateVideoHeight();
        window.addEventListener("resize", this.updateVideoHeight);
        window.addEventListener("beforeunload", this.handlePageUnload);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.updateVideoHeight);
        window.removeEventListener("beforeunload", this.handlePageUnload);

        // 离开页面时保存播放进度
        this.saveVideoProgress(this.classId, this.courseId, this.currentChapter.id, this.$store.getters.userId, this.playerInstance?.getCurrentTime?.(), this.playerInstance?.getDuration());

        if (this.playerInstance) {
            this.playerInstance.dispose();
        }
    },
    methods: {
        async loadCourse() {
            const res = await CourseApi.getCourseChapter(this.courseId, this.classId);
            if (res.code === 0 && Array.isArray(res.data)) {
                this.chapters = res.data.map(ch => ({
                    id: ch.id.toString(), // el-menu 的 index 要用字符串
                    title: ch.chapterTitle,
                }));

                // 获取资源
                await this.loadVodResource(this.courseId);

                if (this.chapters.length > 0) {
                    const chapter = this.chapters.find(chapter => chapter.id === this.$route.params.chapterId.toString());
                    this.currentChapter = {
                        id: chapter.id,
                        title: chapter.title,
                        vodId: chapter.vodId,
                    };

                    // 播放视频
                    await this.loadVideoAuth(this.currentChapter.vodId);
                }
            } else {
                this.$message.error('章节加载失败');
            }
        },
        async loadVodResource(courseId) {
            const res = await VodApi.getVodResource(courseId);
            if (res.code === 0) {
                // 遍历现有章节，给每个章节匹配对应的 vodId
                this.chapters = this.chapters.map(chapter => {
                    const match = res.data.find(vod => vod.chapterId.toString() === chapter.id);
                    return {
                        ...chapter,
                        vodId: match ? match.vodId : null,
                    };
                });
            }
        },
        initPlayer(vid, playAuth) {
            if (this.playerInstance) {
                this.playerInstance.dispose(); // 先销毁旧的播放器实例
            }

            this.playerInstance = new Aliplayer({
                id: 'J_prismPlayer',
                width: '100%',
                height: '100%',
                vid: vid,
                playauth: playAuth,
                autoplay: true,
                license: {
                    domain: 'localhost', // 替换为你申请License时填写的域名
                    key: '6POPhJhXIsNo0F0at10ba7869ca4240b58d4becd2ef59259d',   // 替换为控制台中的 License Key
                }
            }, async () => {
                // 视频加载成功后，获取之前的播放时间
                const lastTimeRes = await VodApi.getProgress(this.classId, this.courseId, this.currentChapter.id); // 假设你有这个接口
                const lastTime = lastTimeRes?.data;
                if (lastTime && this.playerInstance) {
                    this.playerInstance.seek(lastTime); // 跳转到上次进度
                }
            });
        },
        handleSelect(index) {
            const selected = this.chapters.find((c) => c.id === index);
            if (selected) {
                this.saveVideoProgress(this.classId, this.courseId, this.currentChapter.id, this.$store.getters.userId, this.playerInstance?.getCurrentTime?.(), this.playerInstance?.getDuration());

                // 更新 currentChapter（仍然需要）
                this.currentChapter = {
                    id: selected.id,
                    title: selected.title,
                    vodId: selected.vodId,
                };

                // ✅ 更新路由，保持章节状态
                this.$router.push({
                    name: this.$route.name, // 当前页面 name，比如 CourseVideoPage
                    params: {
                        ...this.$route.params,
                        chapterId: selected.id,
                    }
                });

                // 加载视频
                this.loadVideoAuth(selected.vodId);
            }
        },
        async loadVideoAuth(vodId) {
            if (!vodId) {
                this.$message.error('视频加载出错');
                return;
            }
            try {
                const auth = await VodApi.getVideoPlayAuth(vodId);
                // const path = await VodApi.getVideoPlayPath(vodId);
                this.initPlayer(vodId, auth.data);
            } catch (err) {
                this.$message.error('视频加载出错');
            }
        },
        updateVideoHeight() {
            this.$nextTick(() => {
                const container = this.$refs.videoContainer;
                if (container) {
                    const width = container.offsetWidth;
                    this.videoHeight = (width / 16) * 9 + 40; // 40为标题区域高度
                }
            });
        },
        handlePageUnload(event) {
            this.saveVideoProgress(this.classId, this.courseId, this.currentChapter.id, this.$store.getters.userId, this.playerInstance?.getCurrentTime?.(), this.playerInstance?.getDuration(), true); // true = 使用 sendBeacon 同步保存
        },
        saveVideoProgress(classId, courseId, chapterId, createStudent, progress, duration, sync = false) {
            if (progress < 3) return;

            const data = {
                classId: classId,
                courseId: courseId,
                chapterId: chapterId,
                createStudent: createStudent,
                progress: progress,
                duration: duration,
            };

            if (sync) {
                // 页面关闭时用 sendBeacon 确保发出
                // navigator.sendBeacon('http://localhost:48080/app-api/hdjg/vod/send/beacon/save/progress', JSON.stringify(data));
                const url = 'http://localhost:48080/app-api/hdjg/vod/send/beacon/save/progress';
                const blob = new Blob([JSON.stringify(data)], { type: 'application/json' });
                navigator.sendBeacon(url, blob);
            } else {
                VodApi.saveProgress(data).catch(err => {
                    console.warn('保存播放进度失败', err);
                });
            }
        },
        goBack() { 
            console.log(this.$router);
            
            // 这里可以添加查看详情的逻辑
            this.$router.push({
                name: "classCourseDetail",
                params: {
                    // 传递课程ID和班级ID
                    courseId: this.$route.params.courseId,
                    // 其他参数
                    classId: this.$route.params.classId,
                    // className: selectedCourse.courseName,
                    // classImg: selectedCourse.courseImg,
                },

            });
        },
    },

};
</script>

<style scoped>
.course-container {
    background-color: #f7f7f7;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

.main-content {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 20px;
    background-color: #fff;
}

.video-section {
    flex: 2;
    margin-right: 20px;
}

.title-wrapper {
    display: flex;
    align-items: center;
}

.divider {
    color: #ccc;
    font-size: 16px;
    margin: 0px 10px 10px 5px;
}

/* 调整返回按钮和标题之间的间距 */
.return-button {
    color: #333 !important;
    margin: 0 10px 5px 0;
}

.chapter-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;
}

.video-wrapper {
    position: relative;
    width: 100%;
    padding-top: 56.25%;
    /* 16:9 */
    border: 1px solid #ddd;
    border-radius: 8px;
    background-color: #000;
    overflow: hidden;
}

.video-player {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.chapter-list {
    flex: 1;
    width: 300px;
    border: 1px solid #ddd;
    background-color: #fff;
    overflow: hidden;
}

.scrollbar {
    height: 100%;
}

.chapter-menu {
    border: none;
}

.chapter-menu>>>.el-menu-item {
    font-size: 14px;
    color: #444;
    border-bottom: 1px solid #f0f0f0;
}

.chapter-menu>>>.el-menu-item.is-active {
    font-weight: bold;
    color: #409eff;
}
</style>
